import {
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  SUMMARY_PRODUCT_TYPE,
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

const HIDE_CAPITAL_BASE = {
  formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
  hidden: true,
};

export const CAPITAL_BASE_TYPE: FCSelector = {
  formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
  options: [
    {
      id: 'NONE',
      label: 'None',
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
          hidden: true,
        },
      ],
    },
    {
      id: 'FIXED',
      label: 'Fixed',
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
          hidden: false,
        },
      ],
      concatFieldRules: [
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
              effects: [{ ...HIDE_CAPITAL_BASE }],
            },
          ],
        },
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.FLOATING_RATE_NOTE,
              effects: [{ ...HIDE_CAPITAL_BASE }],
            },
          ],
        },
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.DUAL_CURRENCY_NOTE,
              effects: [{ ...HIDE_CAPITAL_BASE }],
            },
          ],
        },
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.REVERSE_CONVERTIBLE,
              effects: [{ ...HIDE_CAPITAL_BASE }],
            },
          ],
        },
        {
          formControlNames: [SUMMARY_PRODUCT_TYPE],
          options: [
            {
              id: ProductTypeEnum.SUPERTRACKER,
              effects: [{ ...HIDE_CAPITAL_BASE }],
            },
          ],
        },
      ],
    },
    {
      id: 'FORWARD',
      label: 'Forward',
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
          hidden: false,
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE],
          hidden: true,
        },
      ],
    },
  ],
};
